import { LanguageService } from '@philips-internal/oswald-ui-core/lib/services';
export class NumberFormatUtils {
    static formatToCurrentLanguage(value, currencySymbol, whiteSpace = false) {
        const currencySymbolWithoutSpace = currencySymbol?.trim();
        const locale = LanguageService.getCurrentLanguage().replace('_', '-');
        const formattedValue = new Intl.NumberFormat(locale, { minimumFractionDigits: 2 }).format(value);
        if (!currencySymbolWithoutSpace) {
            return formattedValue;
        }
        if (currencySymbolWithoutSpace && whiteSpace) {
            return `${currencySymbolWithoutSpace} ${formattedValue}`;
        }
        return `${currencySymbolWithoutSpace}${formattedValue}`;
    }
}
//# sourceMappingURL=number-format-utils.js.map